module.exports = __webpack_public_path__ + "img/icon-activity.8dce5d59.svg";